import { announceCartLinesUpdate } from '@theme/cart-events';

// Govalo adds the card itself and then only navigates to its "#" redirect, so announce the add.
window.addEventListener('govalo:productAddedToCart', (event) => {
  if (!(event instanceof CustomEvent)) return;
  event.preventDefault();
  window.dispatchEvent(new Event('govalo:toggleModal'));

  /** @type {Array<{ id: number, quantity: number }>} */
  const items = event.detail?.items ?? [];
  announceCartLinesUpdate({
    action: 'add',
    lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
    source: 'govalo',
    variantId: items[0] ? String(items[0].id) : undefined,
  });
});

// Before Govalo mounts its trigger, hand an early click on the placeholder over to it once visible.
window.addEventListener(
  'click',
  (event) => {
    // Govalo copies this button's classes onto its own buttons, but not its attributes.
    const placeholder = event.target instanceof Element ? event.target.closest('.js-govalo[ref="addToCartButton"]') : null;
    const container = placeholder?.parentElement;
    if (!container) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const openWhenReady = () => {
      const trigger = container.querySelector('.gvlo-trigger');
      if (!(trigger instanceof HTMLElement) || getComputedStyle(trigger).display === 'none') return false;
      trigger.click();
      return true;
    };
    if (openWhenReady()) return;

    const observer = new MutationObserver(() => openWhenReady() && observer.disconnect());
    observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  },
  { capture: true }
);
